module.exports = __webpack_public_path__ + "img/TinyTAN_Butter01.abb08bc8.jpg";